const userMappings = {
  "users": [
    {
      "uid": "00MibyTeRySzovnA5XXd2jA0PWf2",
      "email": "contact@sumaaroh.com",
      "displayName": "Sumaaroh Contact",
      "phoneNumber": "+918685887746" 
    },
    {
      "uid": "4o1eKktAW7dkbEFhkuIZ81GYCPq2",
      "email": "tanayrajoria2@gmail.com",
      "displayName": "Tanay",
      "phoneNumber": "+919958455611" 
    },
    {
      "uid": "58CduCMw3Lg2cvui2kT68MIuJ6n1",
      "email": "vishu@sumaaroh.com",
      "displayName": "Vishu",
      "phoneNumber": "+919910791010" 
    },
    {
      "uid": "5q79c7qpjBcIxWXhJlEKJsKuzNF3",
      "email": "test@test.com",
      "displayName": "Test User",
      "phoneNumber": "+91" 
    },
    {
      "uid": "bMYFK3Z3g5PK5HlakwsjoryQzer1",
      "email": "yashikagera.sumaroh@gmail.com",
      "displayName": "Yashika",
      "phoneNumber": "+918950204197" 
    },
    {
      "uid": "cnHvSvcnnlY0dJnyUig7ok0Gnbh1",
      "email": "aditya@sumaaroh.com",
      "displayName": "Aditya",
      "phoneNumber": "+919873767211" 
    },
    {
      "uid": "wEsuswj3qVhxCZk1xiDC9jycUCL2",
      "email": "siraj@sumaaroh.com",
      "displayName": "Siraj",
      "phoneNumber": "+919953183606"
    },
    {
      "uid": "5uegkbtTsOXXe10wLLh1kH4Flj32",
      "email": "sejal.sumaroh@gmail.com",
      "displayName": "Sejal",
      "phoneNumber": ""
    },
    {
      "uid": "qfjcJsemeVXC5AeXWCvEBPsxB9y1",
      "email": "pritika.sumaroh@gmail.com",
      "displayName": "Pritika",
      "phoneNumber": ""
    }
  ]
};

export default userMappings;
